import { Component, Input, Injectable, ComponentFactoryResolver, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Overlay } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/material/progress-spinner';
import * as ɵngcc2 from '@angular/cdk/overlay';
class LoaderComponent {
    constructor() {
        this.message = '';
    }
    ngOnInit() { }
}
LoaderComponent.ɵfac = function LoaderComponent_Factory(t) { return new (t || LoaderComponent)(); };
LoaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: LoaderComponent, selectors: [["ff-loader"]], inputs: { message: "message", mode: "mode", value: "value" }, decls: 3, vars: 3, consts: [[3, "mode", "value"]], template: function LoaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "mat-progress-spinner", 0);
        ɵngcc0.ɵɵelementStart(1, "p");
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("mode", ctx.mode)("value", ctx.value);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.message);
    } }, directives: [ɵngcc1.MatProgressSpinner], styles: ["[_nghost-%COMP%]{align-items:center;background-color:hsla(0,0%,100%,.5);display:flex;flex-direction:column;height:100%;justify-content:center;left:0;min-height:100%;position:fixed;top:0;width:100%;z-index:9999}[_nghost-%COMP%]   p[_ngcontent-%COMP%]{color:var(--total-gray-800);font-weight:700}"] });
LoaderComponent.propDecorators = {
    mode: [{ type: Input }],
    value: [{ type: Input }],
    message: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoaderComponent, [{
        type: Component,
        args: [{
                selector: 'ff-loader',
                template: "<mat-progress-spinner [mode]=\"mode\" [value]=\"value\"></mat-progress-spinner>\r\n<p>{{message}}</p>\r\n",
                styles: [":host{align-items:center;background-color:hsla(0,0%,100%,.5);display:flex;flex-direction:column;height:100%;justify-content:center;left:0;min-height:100%;position:fixed;top:0;width:100%;z-index:9999}:host p{color:var(--total-gray-800);font-weight:700}"]
            }]
    }], function () { return []; }, { message: [{
            type: Input
        }], mode: [{
            type: Input
        }], value: [{
            type: Input
        }] }); })();

// @dynamic
class LoaderService {
    constructor(_componentFactoryResolver, _overlay) {
        this._componentFactoryResolver = _componentFactoryResolver;
        this._overlay = _overlay;
        this._overlayRef = _overlay.create();
        this._portal = new ComponentPortal(LoaderComponent);
    }
    add(value) {
        this.show();
        this._componentRef.instance.mode = 'determinate';
        this._componentRef.instance.value += value;
        if (this._componentRef.instance.value >= 100) {
            this._componentRef.instance.value = 0;
            this.hide();
        }
    }
    _reset() {
        if (this._componentRef) {
            this._componentRef.instance.mode = 'indeterminate';
            this._componentRef.instance.value = 0;
        }
    }
    show(message) {
        if (!this._portal.isAttached) {
            this._componentRef = this._overlayRef.attach(this._portal);
            this._componentRef.instance.message = message;
            this._reset();
        }
    }
    hide() {
        if (this._componentRef) {
            this._overlayRef.detach();
            this._componentRef = null;
        }
    }
    isVisible() {
        return this._componentRef;
    }
}
LoaderService.ɵfac = function LoaderService_Factory(t) { return new (t || LoaderService)(ɵngcc0.ɵɵinject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵinject(ɵngcc2.Overlay)); };
LoaderService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: LoaderService, factory: LoaderService.ɵfac });
LoaderService.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: Overlay }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoaderService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc2.Overlay }]; }, null); })();

class LoaderModule {
}
LoaderModule.ɵfac = function LoaderModule_Factory(t) { return new (t || LoaderModule)(); };
LoaderModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: LoaderModule });
LoaderModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [LoaderService], imports: [[CommonModule, MatProgressSpinnerModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoaderModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, MatProgressSpinnerModule],
                declarations: [LoaderComponent],
                providers: [LoaderService],
                exports: []
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(LoaderModule, { declarations: function () { return [LoaderComponent]; }, imports: function () { return [CommonModule, MatProgressSpinnerModule]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { LoaderComponent, LoaderModule, LoaderService };

